export const DistrictsColums = [
  {
    name: "Nombre",
    selector: (row) => row["name"],
    sortable: true,
    center: false,
  },
];
